import IconHOC from '../IconHOC';

import { ReactComponent as StarIcon } from './star.svg';

export const Star = IconHOC(StarIcon);
